import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_119: FaireProductEntity = {
  token: "catalog_prod_prod-119",
  type: "product",
  name: "Garland - Green Mercury Glass Ornaments (Pc)",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop",
  priceDollars: 108.11,
  msrpDollars: 270.27,
  sku: "VI0119",
  caseSize: 2,
  material: "Linen",
  collectionToken: "col_vintage-holiday",
  categoryTokens: ["catalog_cat_makeup"],
  isNew: true,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 146,
  description: "Beautiful Vintage Holiday piece perfect for any home.",
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
